export function delay(ms: number) {
    return new Promise<void>((resolve) => {
        setTimeout(() => resolve(), ms);
    });
}

/**
 * Transforms boolean value to BooleanEnum ('TRUE' | 'FALSE')
 */
export function booleanValueToEnum(value: boolean) {
    return value ? 'TRUE' : 'FALSE';
};

/**
 * Transforms BooleanEnum ('TRUE' | 'FALSE') to boolean value
 */
export function enumValueToBoolean(value: 'TRUE' | 'FALSE') {
    return value === 'TRUE';
}
